import axios from 'axios';

// Types
export interface UserInfo {
    _id: string;
    username: string;
    email: string;
    role: string;
    token: string;
    createdAt?: string;
}

// Register user
export const registerUser = async (
    username: string,
    email: string,
    password: string,
    role: string = 'user'
): Promise<UserInfo> => {
    try {
        const response = await axios.post('/api/users', {
            username,
            email,
            password,
            role
        });

        if (response.data) {
            localStorage.setItem('userInfo', JSON.stringify(response.data));
        }

        return response.data;
    } catch (error) {
        console.error('Error registering user:', error);
        throw error;
    }
};

// Login user
export const loginUser = async (
    email: string,
    password: string
): Promise<UserInfo> => {
    try {
        const response = await axios.post('/api/users/login', {
            email,
            password,
        });

        if (response.data) {
            localStorage.setItem('userInfo', JSON.stringify(response.data));
        }

        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};

// Logout user
export const logout = (): void => {
    localStorage.removeItem('userInfo');
};

// Get current user from localStorage
export const getCurrentUser = (): UserInfo | null => {
    const userInfoString = localStorage.getItem('userInfo');
    if (userInfoString) {
        return JSON.parse(userInfoString);
    }
    return null;
};

// Set auth header
export const setAuthHeader = (token: string): void => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// Clear auth header
export const clearAuthHeader = (): void => {
    delete axios.defaults.headers.common['Authorization'];
};

// Get user profile
export const getUserProfile = async (): Promise<UserInfo> => {
    try {
        const userInfo = getCurrentUser();
        if (userInfo) {
            setAuthHeader(userInfo.token);
        }

        const response = await axios.get('/api/users/profile');
        return response.data;
    } catch (error) {
        console.error('Error getting user profile:', error);
        throw error;
    }
};

// Get all users (admin only)
export const getAllUsers = async (): Promise<UserInfo[]> => {
    try {
        const userInfo = getCurrentUser();
        if (userInfo) {
            setAuthHeader(userInfo.token);
        }

        const response = await axios.get('/api/users');
        return response.data;
    } catch (error) {
        console.error('Error getting all users:', error);
        throw error;
    }
}; 